import { render, staticRenderFns } from "./dealmakers.vue?vue&type=template&id=5a623f3c"
import script from "./dealmakers.vue?vue&type=script&lang=js"
export * from "./dealmakers.vue?vue&type=script&lang=js"
import style0 from "./dealmakers.vue?vue&type=style&index=0&id=5a623f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports